import React from "react";
import "./contact.css";
import { Fade } from "react-reveal";
import { FiTwitter, FiLinkedin, FiGithub } from "react-icons/fi";
import { usePortfolioData } from "../../hooks/usePortfolioData";

const Contact = () => {
  const { data, loading } = usePortfolioData();

  if (loading || !data) {
    return (
      <div className="contact-container" id="contact">
        <div>Loading...</div>
      </div>
    );
  }

  const { contact, personal } = data;

  return (
    <div className="contact-container" id="contact">
      <Fade delay={100}>
        <div className="next">{contact.subtitle}</div>
      </Fade>
      <Fade delay={150}>
        <div className="contact-header">{contact.title}</div>
      </Fade>
      <Fade delay={200}>
        <div className="contact-text">{contact.message}</div>
      </Fade>
      <Fade delay={300}>
        <a className="contact-btn" href={`mailto:${personal.email}`}>
          {contact.ctaText}
        </a>
      </Fade>
      <Fade delay={300}>
        <div className="contact-socials">
          <a
            className="contact-social"
            href={personal.twitter}
            target="_blank"
            rel="noreferrer"
          >
            <FiTwitter />
          </a>
          <a
            className="contact-social"
            href={personal.linkedin}
            target="_blank"
            rel="noreferrer"
          >
            <FiLinkedin />
          </a>
          <a
            className="contact-social"
            href={personal.github}
            target="_blank"
            rel="noreferrer"
          >
            <FiGithub />
          </a>
        </div>
      </Fade>
    </div>
  );
};

export default Contact;
